import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { SandboxLogViewComponent } from '../component/page/sandbox-log-view/sandbox-log-view.component';
import { SandboxPageComponent } from '../component/page/sandbox-page/sandbox-page/sandbox-page.component';
import { ViewSandboxPageStateComponent } from '../component/poc/view-sandbox-page-state/view-sandbox-page-state.component';
import { Xml2jsonComponent } from '../component/poc/xml2json/xml2json.component';
import { AddAncilliariesScreenComponent } from '../component/screen/add-ancilliaries-screen/add-ancilliaries-screen.component';
import { AddBaggageScreenComponent } from '../component/screen/add-baggage-screen/add-baggage-screen.component';
import { AddMealScreenComponent } from '../component/screen/add-meal-screen/add-meal-screen.component';
import { AddSeatsAncilliariesScreenComponent } from '../component/screen/add-seats-ancilliaries-screen/add-seats-ancilliaries-screen.component';
import { AirlineOffersScreenComponent } from '../component/screen/airline-offers-screen/airline-offers-screen.component';
import { ApiConnectionProfileScreenComponent } from '../component/screen/api-connection-profile-screen/api-connection-profile-screen.component';
import { CancelBookingRefundQuoteScreenComponent } from '../component/screen/cancel-booking-refund-quote-screen/cancel-booking-refund-quote-screen.component';
import { ChangeFlightDateTimeComponent } from '../component/screen/change-flight-date-time/change-flight-date-time.component';
import { ConfirmBookingScreenComponent } from '../component/screen/confirm-booking-screen/confirm-booking-screen.component';
import { FindOrderScreenComponent } from '../component/screen/find-order-screen/find-order-screen.component';
import { IssueTicketsScreenComponent } from '../component/screen/issue-tickets-screen/issue-tickets-screen.component';
import { OfferPriceScreenComponent } from '../component/screen/offer-price-screen/offer-price-screen.component';
import { PassengerDetailsScreenComponent } from '../component/screen/passenger-details-screen/passenger-details-screen.component';
import { PassengerNameChangeScreenComponent } from '../component/screen/passenger-name-change-screen/passenger-name-change-screen.component';
import { SeatSelectionScreenComponent } from '../component/screen/seat-selection-screen/seat-selection-screen.component';
import { SplitBookingScreenComponent } from '../component/screen/split-booking-screen/split-booking-screen.component';
import { YourBookingScreenComponent } from '../component/screen/your-booking-screen/your-booking-screen.component';
import { AuthGuardService } from '../service/auth-guard.service';

const routes: Routes = [
  { path: 'sandbox', component: SandboxPageComponent, canActivate: [AuthGuardService] },
  { path: 'newSandbox', component: SandboxPageComponent, canActivate: [AuthGuardService] },
  { path: 'viewLog/:id', component: SandboxLogViewComponent, canActivate: [AuthGuardService] },
  { path: 'viewSandboxPageState', component: ViewSandboxPageStateComponent },
  { path: 'xml2json', component: Xml2jsonComponent },
  { path: 'airlineOffers', component: AirlineOffersScreenComponent },
  { path: 'yourBooking', component: YourBookingScreenComponent },
  { path: 'flightOffers', component: AirlineOffersScreenComponent },
  { path: 'findOrders', component: FindOrderScreenComponent },
  { path: 'passengerDetails', component: PassengerDetailsScreenComponent },
  { path: 'passengrNameChanges', component: PassengerNameChangeScreenComponent },
  { path: 'issueTickets', component: IssueTicketsScreenComponent },
  { path: 'offerPrice', component: OfferPriceScreenComponent },
  { path: 'addAncilliaries', component: AddAncilliariesScreenComponent },
  { path: 'add-baggage', component: AddBaggageScreenComponent },
  { path: 'addMeal', component: AddMealScreenComponent },
  { path: 'addSeats', component: AddSeatsAncilliariesScreenComponent },
  { path: 'splitBooking', component: SplitBookingScreenComponent },
  { path: 'changeDateTime', component: ChangeFlightDateTimeComponent },
  { path: 'cancel/booking', component: CancelBookingRefundQuoteScreenComponent },
  { path: 'seatSelection', component: SeatSelectionScreenComponent },
  { path: 'confirmBooking', component: ConfirmBookingScreenComponent },
  { path: 'newConnection', component: ApiConnectionProfileScreenComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppSandboxRoutingModule {}
